import i18n from 'i18next';

const translate = (key: string | string[], options?: Object): string => {
  return i18n.t(key, options);
};

export default translate;
